import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

const CACHE_TTL_MS = 5 * 60 * 1000;
const _cache = new Map();

export function cachedGet(path) {
  const now = Date.now();
  const entry = _cache.get(path);
  if (entry && now - entry.time < CACHE_TTL_MS) return entry.promise;
  const promise = api.get(path).catch((err) => {
    _cache.delete(path);
    throw err;
  });
  _cache.set(path, { time: now, promise });
  return promise;
}
